<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="stories" v-if="stories.length">
                    <swiper class="stories__thumbs" ref="thumbsRef" :options="storyThumbs">
                    <template v-for="({ main_image }, idx) in stories">
                        <swiper-slide
                        @click.native="slideClicked(idx)"
                        :key="idx"
                        >
                        <progress-circle
                            :image="useConvertFilter(`/storage/${main_image.path}`, 'preview')"
                            :percent="100"
                            :is-show-progress="true"
                            w="72"
                            stroke-width="5"
                        ></progress-circle>
                        </swiper-slide>
                    </template>
                    </swiper>

                    <transition name="modal">
                    <div class="stories__modal" v-show="showModal">
                        <div class="stories__modal-wrapper d-flex">
                        <div class="stories__modal-header d-flex">
                            <img src="/assets/images/icons/logo-white.svg" alt="" />
                            <a @click.prevent="closeModal"
                            ><span class="lnr lnr-cross"></span
                            ></a>
                        </div>
                        <div class="stories__modal-swiper d-flex">
                            <swiper
                            @slideChange="slideChange"
                            class="stories__gallery"
                            ref="galleryRef"
                            :options="storyGallery"
                            >
                            <template v-if="stories.length">
                                <template v-for="(slide, idx) in stories">
                                <swiper-slide
                                    :class="{
                                    'stories--prev': idx < slideIndex - 1,
                                    'stories--prev-last': idx === slideIndex - 2,
                                    }"
                                    :key="idx"
                                >
                                    <div
                                    class="stories__gallery-item d-flex swiper-lazy"
                                    :data-background="
                                        useConvertFilter(
                                        `/storage/${slide.main_image.path}`,
                                        'full'
                                        )
                                    "
                                    >
                                    <transition name="fade">
                                        <div
                                        class="stories__gallery-info"
                                        v-show="idx !== slideIndex"
                                        >
                                        <progress-circle
                                            font-size="24"
                                            font-size-percent="17"
                                            :image="
                                            useConvertFilter(
                                                `/storage/${slide.main_image.path}`,
                                                'preview'
                                            )
                                            "
                                            :percent="100"
                                            w="98"
                                            stroke-width="5"
                                        ></progress-circle>
                                        <div
                                            class="stories__gallery-info-name"
                                            v-text="slide.title"
                                        ></div>
                                        </div>
                                    </transition>
                                    <transition name="fade">
                                        <div
                                        class="stories__gallery-content"
                                        v-show="idx === slideIndex"
                                        >
                                        <div class="stories__gallery-header d-flex">
                                            <a
                                            :href="`/blog/${slide.category.slug}/${slide.slug}`"
                                            class="stories__thumbs-item p-0"
                                            >
                                            <progress-circle
                                                :image="
                                                useConvertFilter(
                                                    `/storage/${slide.main_image.path}`,
                                                    'avatar'
                                                )
                                                "
                                                :percent="100"
                                                w="30"
                                                stroke-width="2"
                                            />
                                            </a>
                                            <a
                                            :href="`/blog/${slide.category.slug}/${slide.slug}`"
                                            class="stories__gallery-info-name"
                                            v-text="slide.title"
                                            ></a>
                                        </div>
                                        <div
                                            v-if="slide.content &&
                                                 (idx >= slideIndex - 2 || idx <= slideIndex + 2)"
                                        >
                                            <div class="stories__gallery-body">
                                            <a
                                                :href="`/blog/${slide.category.slug}/${slide.slug}`"
                                                class="read-more-button"
                                                >{{$store.getters.t('blog_storyline_go_to_article')}}</a>
                                            
                                            </div>
                                        </div>
                                        </div>
                                    </transition>
                                    </div>
                                </swiper-slide>
                                </template>

                                <div
                                    class="story-btn story-prev"
                                    @click="prevSlide"
                                    slot="button-prev"
                                >
                                    <span class="lnr lnr-chevron-left"></span>
                                </div>
                                <div
                                    class="story-btn story-next"
                                    @click="nextSlide"
                                    slot="button-next"
                                >
                                    <span class="lnr lnr-chevron-right"></span>
                                </div>
                            </template>
                            </swiper>
                        </div>
                        </div>
                    </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProgressCircle from "../chunk/ProgressCircle.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { getPosts } from "./api";

export default {
  name: "StoryLine",
  components: {
    Swiper,
    SwiperSlide,
    ProgressCircle,
  },
  props: {
    isShowProgress: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      stories: [],
      showModal: false,
      slideIndex: 0,
      storyThumbs: {
        spaceBetween: 16,
        slidesPerView: "auto",
        speed: 700,
        freeMode: false,
      },
      storyGallery: {
        spaceBetween: 0,
        slidesPerView: "auto",
        speed: 700,
        preloadImages: false,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 3,
          checkInView: true,
        },
        watchSlidesVisibility: true,
        breakpoints: {
          // when window width is >= 320px
          320: {
            lazy: {
              loadPrevNextAmount: 1,
            },
          },

          992: {
            lazy: {
              loadPrevNextAmount: 3,
            },
          },
        },
      },
    };
  },
  watch: {},
  computed: {
    thumbsSwiper() {
      if (!this.stories && !this.showModal) return;
      return this.$refs.thumbsRef.$swiper;
    },

    gallerySwiper() {
      if (!this.stories && !this.showModal) return;
      return this.$refs.galleryRef.$swiper;
    },
  },

  mounted() {
    this.fetchPosts();
    this.$nextTick(() => {
      if( !this.stories.length ) return
      const thumbs = this.$refs.thumbsRef.$swiper
      const gallery = this.$refs.galleryRef.$swiper
      gallery.controller.control = thumbs
    });
  },

  methods: {
    async fetchPosts() {
      let { data, success = false } = await getPosts();
      if (success) this.stories = data;
    },

    useConvertFilter(path, replacer) {
      return this.$options.filters.convertImage(path, replacer);
    },
    closeModal() {
      this.showModal = false;
      this.readMore = false;
      $("html").removeClass("modal-open");
    },
    slideChange() {
      this.readMore = false;
      this.slideIndex = this.gallerySwiper.activeIndex;
    },
    nextSlide() {
      this.readMore = false;
      this.gallerySwiper.slideNext();
    },
    prevSlide() {
      this.readMore = false;
      this.gallerySwiper.slidePrev();
    },
    slideClicked(idx) {
      $("html").addClass("modal-open");

      this.readMore = false;
      this.slideIndex = idx;
      this.gallerySwiper.lazy.load();
      this.gallerySwiper.slideTo(idx);
      this.showModal = true;
    },
  },
};
</script>

<style lang="scss">
.stories__gallery-body {
  position: absolute;
  bottom: 30px;
  left: 20px;
  right: 20px;
  width: calc(100% - 40px);
  z-index: 2;

  *:not(a) {
    color: #fff !important;
  }

  a {
    color: #2e76e4 !important;
    transition: 0.2s ease;

    &:hover {
      opacity: 0.8;
    }
  }

  .read-more-button {
    width: 100%;
    border: 1px solid white;
    border-radius: 25px;
    padding: 5px 0;
    font-size: 12px;
    margin-top: 10px;
  }
}

.stories__gallery-body-full {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 80%;
  width: 100%;
  background: #fff;
  border-radius: 20px 20px 0 0;
  color: #333333;
  transition: height 400ms;
  overflow: hidden;
  z-index: 10;

  &-bg {
    z-index: 5;
    height: 100%;
    width: 100%;
    cursor: pointer;
    top: 0;
    left: 0;
    position: absolute;
    background: #0000002e;
  }

  &-title {
    padding: 15px 35px;
    font-size: 14px;
    line-height: 16px;
    border-bottom: 1px solid #f1f2f4;
    height: 10%;
    font-weight: bold;

    div {
      position: absolute;
      right: 20px;
      top: 15px;
      cursor: pointer;
    }
  }

  &-content {
    height: 75%;
    padding: 24px;
    overflow: auto;
  }

  &-footer {
    height: 15%;
    width: 100%;
    border-top: 1px solid #f1f2f4;
    position: absolute;
    bottom: 0;
  }
}
</style>

<style lang="scss" scoped>

.stories__thumbs-item{
    flex-shrink: 0;
}

.stories__gallery-info-name{
    color: #0056b3
}

.stories__gallery-info{
    padding: 0 10px;
}

.progress-circle-component{
    margin: 0 auto;
}

.stories__thumbs-story {
  width: 100%;
  height: 68px;
  background: #2e76e4;
  color: #fff;
  font-size: 40px;
  line-height: 1;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
}

.read-more-button {
    display: block;
    padding: 10px 20px;
    text-align: center;
    color: #fff !important;
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.2s ease 0.2s;
}

.modal-enter, .modal-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}
</style>
